import {
  copyHorizonApi,
  getAddedElementsSelectabilityApi,
  getElementsByParentIdApi,
  getTopLevelElementsByProjectIdApi,
  publishElementsApi,
  publishElementsByEntityIdApi,
} from '@core/core/api'
import { draftTooltipInTreeIsHidden } from '@core/core/constants'
import { setToStorage } from '@core/core/helpers'
import type { ActiveEntity } from '@core/core/types'
import type {
  BaseObject,
  ProjectElementId,
  ProjectElementInfo,
  ProjectId,
  TabId,
} from 'common/types'

import { selectActiveProjectId } from '../project'
import type { AppThunk } from '../store'
import {
  selectActiveTab,
  selectActiveTabIdInWorkArea,
  selectActiveWorkAreaId,
  setTabElementStateByEntityId,
  updateTreeElementStates,
} from '../workArea'
import { treeObjectsSlice } from './treeObjectSlice'

export const { addNewNodes, updateExistingNodes, deleteNodes } = treeObjectsSlice.actions
const { addTreeElementsByParentId, clearTreeElements } = treeObjectsSlice.actions

export const getTopNodesByProjectId =
  (projectId: ProjectId): AppThunk =>
  async dispatch => {
    try {
      dispatch(clearTreeElements())
      const elements = await getTopLevelElementsByProjectIdApi(projectId)
      dispatch(addTreeElementsByParentId({ nodes: elements }))
    } catch (ex) {
      console.log(ex)
    }
  }

export const getNodesByParentId =
  (projectId: ProjectId, parentId: string, tabId?: TabId): AppThunk =>
  async dispatch => {
    try {
      const elements = await getElementsByParentIdApi(projectId, parentId, tabId)
      dispatch(addTreeElementsByParentId({ parentId, nodes: elements }))
      elements.map(elem => dispatch(updateTreeElementStates(elem.tabElements)))
    } catch (ex) {
      console.log(ex)
    }
  }

export const getAddedElementsSelectability =
  (elements: ProjectElementInfo[]): AppThunk =>
  async (dispatch, getState) => {
    const state = getState()
    const projectId = selectActiveProjectId(state)
    const workAreaId = selectActiveWorkAreaId(state)
    if (workAreaId && projectId !== '') {
      const tabId = selectActiveTabIdInWorkArea(state, workAreaId)
      if (tabId) {
        await getAddedElementsSelectabilityApi(projectId, tabId, elements)
      }
    }
  }

export const checkCreatedTreeObject =
  (projectId: ProjectId, id: string, entityType: BaseObject): AppThunk =>
  (dispatch, getState) => {
    const tab = selectActiveTab(getState())
    if (!tab) return

    dispatch(setTabElementStateByEntityId(projectId, id, entityType, tab.id, 'Checked'))
  }

export const publishElements =
  (projectId: ProjectId, elementId: ProjectElementId): AppThunk =>
  () => {
    publishElementsApi(projectId, elementId)
    setToStorage(draftTooltipInTreeIsHidden, String, true)
  }

export const publishElementsByEntityId =
  (projectId: ProjectId, entity: ActiveEntity): AppThunk =>
  () => {
    if (entity.entityId) {
      publishElementsByEntityIdApi(projectId, entity.entityId, entity.entityType)
      setToStorage(draftTooltipInTreeIsHidden, String, true)
    }
  }

export const copyHorizon =
  (projectId: ProjectId, elementId: string): AppThunk =>
  () => {
    copyHorizonApi(projectId, elementId)
  }
